export interface TabSelectionItem {
    tabLabel: string;
    tabName: string;
}

export const organizationsBothTabs: TabSelectionItem[] = [
    {
        tabLabel: 'Customer numbers',
        tabName: 'customerNumbers'
    },{
        tabLabel: 'Users',
        tabName: 'usernames'
    }
]

export const organizationsOneTab: TabSelectionItem[] = [
    {
        tabLabel: 'Customer numbers',
        tabName: 'customerNumbers'
    }
]